import useMutationApi from '../useMutationApi';
import { SupportedModelId } from '@erp/shared-types';

interface ParseCsvFromImageRequest {
  files: File[];
  context?: string;
  customInstructions?: string;
  model?: SupportedModelId;
}

interface ParseCsvFromImageResponse {
  csvData: string;
  explanation: string;
  constants?: {
    supplierId?: string;
    currency?: string;
    dateRange?: { startDate: string; endDate: string };
  };
}

const useParseCsvFromImage = () => {
  return useMutationApi<ParseCsvFromImageRequest, ParseCsvFromImageResponse>({
    endpoint: 'spreadsheet/parse-csv-from-image',
    method: 'POST',
    transformRequest: (body: ParseCsvFromImageRequest) => {
      const formData = new FormData();
      body.files.forEach((file, _index) => {
        formData.append(`files`, file);
      });
      if (body.context) {
        formData.append('context', body.context);
      }
      if (body.customInstructions) {
        formData.append('customInstructions', body.customInstructions);
      }
      if (body.model) {
        formData.append('model', body.model);
      }
      return formData;
    },
    successMessage: 'Files parsed to CSV successfully',
  });
};

export default useParseCsvFromImage;
